import { reset_right_rail } from "../../reducers/RightRail/reducer";
import { fetch_supplementary_data } from "../../actions/RightRail/dispatchers";
import {
    setAppState,
    setAppError,
    titleUpdate,
} from "../../actions/App/dispatchers";
import { fetch_tracking } from "../../actions/Tracking/dispatchers";
import { reset_app_state } from "../../actions/Page/asyncDispatchers";
import { fetch_sectional_content_all_sports } from "../../actions/SectionalContent/dispatchers";

export const fetchLandingCategoriesPageData = (path) => async (dispatch) => {
    const url = path.slice(1);

    // Page title hardcoded for olympics SEO
    const pageTitle = /\/winter\//.test(url)
        ? "Olympic Sports - CBC Olympic Winter Games Beijing 2022"
        : "Summer Olympic Sports - CBC Sports";

    dispatch(reset_app_state(path));
    dispatch(reset_right_rail());
    dispatch(titleUpdate(pageTitle));

    try {
        await dispatch(fetch_sectional_content_all_sports(url));
        await dispatch(fetch_tracking({}, false));
        await dispatch(fetch_supplementary_data(url));
        dispatch(setAppState(path, false, ""));
    } catch (error) {
        dispatch(setAppError(path, error.code));
    }
};
